import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportarAExcel = (datos, nombreArchivo = "datos.xlsx") => {
  // Crea una hoja con los datos (array de objetos)
  const hoja = XLSX.utils.json_to_sheet(datos);

  // Crea un libro y le agrega la hoja
  const libro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(libro, hoja, "Hoja1");

  // Genera el archivo
  const excelBuffer = XLSX.write(libro, {
    bookType: "xlsx",
    type: "array",
  });

  // Lo guarda usando FileSaver
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(blob, nombreArchivo);
};
